// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9af712b5","455":"7230d1ba","977":"968af4df"}[chunkId] + ".chunk.js";
};